import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as l, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconPictureInPicture",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, i, _, p, a) {
  return d(), n("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--picture-in-picture"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Picture In Picture",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, [...t[0] || (t[0] = [
    o("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 3a1.5 1.5 0 0 1 1.5-1.5H8A1.5 1.5 0 0 1 9.5 3v1a.5.5 0 1 1-1 0V3a.5.5 0 0 0-.5-.5H2.5A.5.5 0 0 0 2 3v3a.5.5 0 0 0 .5.5h1a.5.5 0 1 1 0 1h-1A1.5 1.5 0 0 1 1 6V3Zm4 4a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 11 7v2a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 5 9V7Zm1.5-.5A.5.5 0 0 0 6 7v2a.5.5 0 0 0 .5.5h3A.5.5 0 0 0 10 9V7a.5.5 0 0 0-.5-.5h-3Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])], 10, u);
}
const A = /* @__PURE__ */ s(c, [["render", m]]);
export {
  A as default
};
//# sourceMappingURL=picture-in-picture.js.map
